import { ElementOrID } from '../types';
import { getClassNames } from './getClassNames';

export function hasClass(elementOrId: ElementOrID, className: string): boolean {
  return getClassNames(elementOrId).includes(className);
}
